import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Col,
  Row,
  Form,
  Input,
  Radio,
  TimePicker,
  Descriptions,
  Select
} from "antd";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateOFRMaster } from "../../../@app/subMaster/subMasterSlice";
import { useLocation } from "react-router-dom";
import messageToast from "../../../components/messageToast/messageToast";
import { transStatus } from "../../../util/transStatus";
import {
  getDefinitionsList,
  getOFRMaster
} from "../../../@app/subMaster/subMasterSlice";

import { map } from "ramda";

const { Option } = Select;

function OFRMasterEditForm() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    state: { data: defaultValue }
  } = useLocation();

  const { state } = useLocation();
  const [status, setStatus] = useState(defaultValue?.status ?? 1);
  const [loading, setLoading] = useState(false);
  const { savingOFRMaster } = useSelector((state) => {
    return state.subMaster;
  });

  useEffect(() => {
    dispatch(getDefinitionsList());
  }, []);

  const {
    gettingDefinitionsList,
    getDefinitionsListResponse: { data: def1 }
  } = useSelector((state) => {
    return state.subMaster;
  });

  const format = "HH:mm:ss";

  const [selectedTime, setSelectedTime] = useState("");

  let formattedTime;
  const onDurationChange = (e) => {
    const hours = e["$d"].getHours();
    const minutes = e["$d"].getMinutes();
    const seconds = e["$d"].getSeconds();
    // Format the time as HH:MM:SS
    formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    setSelectedTime(formattedTime);
  };

  useEffect(() => {
    dispatch(getDefinitionsList());
  }, []);

  useEffect(() => {
    dispatch(getOFRMaster());
  }, []);

  const {
    userData: { data: datanew }
  } = useSelector((state) => {
    return state.auth;
  });

  const onFinish = (data) => {
    setLoading(false);
    dispatch(
      //?
      updateOFRMaster({
        data: {
          id: state?.id,
          time: selectedTime,
          status: transStatus({ status }) || status,
          checklist_name: data?.checklist_name || state?.checklist_name,
          temperature: data?.temperature || state?.temperature,
          check_list_type: data?.check_list_type || state?.check_list_type,
          functional_type: data?.functional_type || state?.functional_type,
          updated_by: datanew?.id ?? "0"
        }
      })
    ).then(({ message, status, statusText }) => {
      if (status === 200) {
        setLoading(true);
        messageToast({
          message: message ?? statusText,
          status,
          title: "OFR Master Edit Status"
        });
        navigate("/OFRMaster");
        form.resetFields();
      } else {
        messageToast({
          message: message ?? statusText,
          status,
          title: "OFR Master Status"
        });
      }
    });
  };
  const handleClickBack = () => {
    navigate("/OFRMaster");
  };

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <>
      <Card>
        <Row style={{ justifyContent: "center" }}>
          <Col span={24}>
            <Form
              //onFieldsChange={() => setShowDialog(true)}
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              onFinish={onFinish}
              disabled={savingOFRMaster}
              form={form}
              initialValues={{
                status: defaultValue?.status ?? 1,
                ...defaultValue
              }}
              autoComplete="off"
            >
              <Row gutter={[15, 0]}>
                <Descriptions bordered size="small">
                  <Descriptions.Item
                    label={"OFR Check List Type"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col>
                      <Form.Item name="check_list_type">
                        <Select
                          placeholder="Select"
                          style={{
                            width: "250px",
                            height: "34px",
                            border: "2px solid #f5a60b",
                            borderRadius: "10px"
                            //  padding:"2px"
                          }}
                          name="type"
                          loading={gettingDefinitionsList}
                          // onChange={(e) => setCheckListType(e)}
                          defaultValue={state?.check_list_type}
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {map(
                            (state) => {
                              return (
                                <Option key={state.id} value={state.id}>
                                  {state.def_list_name}
                                </Option>
                              );
                            },
                            def1
                              ? def1?.filter(
                                  (e) =>
                                    e.def_title == "OFR Check List" &&
                                    e.status == 1
                                )
                              : []
                          )}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>

                  <Descriptions.Item
                    label={"Functional Type"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col>
                      <Form.Item name="functional_type">
                        <Select
                          placeholder="Select"
                          style={{
                            width: "250px",
                            height: "34px",
                            border: "2px solid #f5a60b",
                            borderRadius: "10px"
                          }}
                          name="type"
                          loading={gettingDefinitionsList}
                          //   onChange={(e) => setFunctionalType(e)}
                          defaultValue={state?.functional_type}
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {map(
                            (state) => {
                              return (
                                <Option key={state.id} value={state.id}>
                                  {state.def_list_name}
                                </Option>
                              );
                            },
                            def1
                              ? def1?.filter(
                                  (e) =>
                                    e.def_title == "Functional Type" &&
                                    e.status == 1
                                )
                              : []
                          )}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Particulars Name"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                      <Form.Item name="checklist_name">
                        <Input
                          style={{ width: "250px" }}
                          placeholder="Enter CheckList Name"
                          defaultValue={state?.checklist_name}
                        />
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Temperature"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                      <Form.Item name="temperature">
                        <Input
                          style={{ width: "250px" }}
                          placeholder="Enter Temperature Name"
                          defaultValue={state?.temperature}
                        />
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Time"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                      <Form.Item name="timeold">
                        <Input
                          style={{
                            width: "170px",
                            background: "#cdd4cf",
                            color: "#000000"
                          }}
                          defaultValue={state?.time}
                        />
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Time"}
                    style={{ width: "150px" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col md={{ span: 6 }} xs={{ span: 24 }}>
                      <Form.Item
                        name="time"

                        // rules={[{ required: true, message: "Please enter Time" }]}
                      >
                        <TimePicker
                          placeholder="Time"
                          style={{ width: "170px" }}
                          //defaultValue={state?.time}
                          value={formattedTime}
                          onChange={onDurationChange}
                          format={format}
                          name="call_duration"
                        />
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={" * Status"}
                    style={{ width: "150px", color: "#f70707" }}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col span={24}>
                      <Form.Item
                        name="status"
                        //label="Status"
                        rules={[
                          {
                            required: true,
                            message: "Please select your status"
                          }
                        ]}
                      >
                        <Col span={24}>
                          <Col span={24}>
                            <Radio.Group
                              buttonStyle="solid"
                              onChange={(e) => {
                                setStatus(e?.target?.value);
                              }}
                              size="small"
                              defaultValue={
                                defaultValue?.status === "In Active" ? 0 : 1
                              }
                            >
                              <Radio.Button className="active" value={1}>
                                Active
                              </Radio.Button>
                              <Radio.Button className="in-active" value={0}>
                                In-Active
                              </Radio.Button>
                            </Radio.Group>
                          </Col>
                        </Col>
                      </Form.Item>
                    </Col>
                  </Descriptions.Item>
                </Descriptions>
                <Col span={24}>
                  <Form.Item>
                    <Button
                      onClick={handleClickBack}
                      disabled={savingOFRMaster}
                    >
                      Back
                    </Button>
                  </Form.Item>
                  <Row gutter={[15, 15]} style={{ justifyContent: "end" }}>
                    <Col
                      span={12}
                      style={{ textAlign: "right" }}
                      className="d-flex align-items-center justify-content-end mt-3"
                    >
                      <Form.Item className="mx-2">
                        <Button
                          className="orangeFactory"
                          type="primary"
                          htmlType="submit"
                          loading={loading}
                          disabled={savingOFRMaster}
                        >
                          {"Update"}
                        </Button>
                      </Form.Item>
                      {/* </Col>
                    <Col span={12}> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default OFRMasterEditForm;
